import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Preloader from "@/components/Preloader";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Vault from "@/components/Vault";
import GalleryWall from "@/components/GalleryWall";
import StickerShelf from "@/components/StickerShelf";
import Footer from "@/components/Footer";
import Ambient from "@/components/Ambient";
import { fetchProgress } from "@/lib/api";

const EMPTY_PROGRESS = { completed: [], count: 0, unlocked_count: 0, stickers: [] };

export default function Home() {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(EMPTY_PROGRESS);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    fetchProgress()
      .then(setProgress)
      .catch(() => {});
  }, []);

  return (
    <div className="relative min-h-screen bg-ink text-paper">
      <AnimatePresence>{loading && <Preloader key="preloader" />}</AnimatePresence>
      <Ambient />
      <Navbar />
      <main className="relative">
        <Hero />
        <Marquee />
        <Vault progress={progress} />
        <Marquee />
        <GalleryWall />
        <StickerShelf progress={progress} />
      </main>
      <Footer />
    </div>
  );
}
